const disabledMenu = isDisabled =>
  isDisabled
    ? {
        textDecoration: 'none',
        pointerEvents: 'none',
        outline: 0,
        cursor: 'not-allowed',
      }
    : { textDecoration: 'none', outline: 0 };

export default disabledMenu;
